import { useSegmentation } from '@printdeal/segmentation/react';
import { defineMessages } from 'react-intl';
import { MessagesList } from '../types/Message';

export const dynamicQuoteMessage = () => {
  const { data: segmentationData } = useSegmentation();
  if (!segmentationData) {
    return '48';
  }
  const { category } = segmentationData || {};
  switch (category) {
    case 'Basic':
      return '12';
    case 'Plus':
      return '8';
    case 'Pro':
      return '8';
    case 'Premium':
      return '4';
    case 'Excellent':
      return '4';
    default:
      return '48';
  }
};

export const progressBarTranslations: MessagesList = defineMessages({
  basic: {
    id: 'account.dashboard.customerProgram.category.basic',
    defaultMessage: 'Basic',
  },
  plus: {
    id: 'account.dashboard.customerProgram.category.plus',
    defaultMessage: 'Plus',
  },
  pro: {
    id: 'account.dashboard.customerProgram.category.pro',
    defaultMessage: 'Pro',
  },
  premium: {
    id: 'account.dashboard.customerProgram.category.premium',
    defaultMessage: 'Premium',
  },
  excellent: {
    id: 'account.dashboard.customerProgram.category.excellent',
    defaultMessage: 'Excellent',
  },
});

export const convertToCents = (euros: number) => Math.round(euros * 100);
